/* eslint-disable @typescript-eslint/no-empty-function */
import Plyr from "plyr";
import React, { useRef, ReactNode, useCallback } from "react";
import { Theme, StandardProps } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "../typescript";
import { defaultTo } from "lodash-es";

const styles = (theme: Theme) => createStyles({});

type AppPlyrClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface AppPlyrProps extends StandardProps<any, AppPlyrClassKey> {
    poster?: string;
    url?: string;
    onPlayerInstance?: (p: Plyr) => void;
    mimeType?: string;
    playsInline?: boolean;
    controls?: boolean;
    children?: ReactNode;
    options?: any;
    controlVisibilityChanged?: (visible: boolean) => void;
    fullScreenToggled?: (visible: boolean) => void;
    playingStatusChanged?: (visible: boolean) => void;
}

function Component(props: AppPlyrProps) {
    const {
        poster,
        url,
        mimeType,
        onPlayerInstance = () => {},
        controlVisibilityChanged = () => {},
        children,
        fullScreenToggled = () => {},
        playingStatusChanged = () => {},
        ...rest
    } = props;
    const plyrRef = useRef<Plyr>();
    const playsInline = defaultTo(rest.playsInline, true);
    const controls = defaultTo(rest.controls, true);
    const options = defaultTo(rest.options, {});

    const defaultOptions = {
        controls: [
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "pip",
            "fullscreen"
        ],
        settings: ["speed", "loop"],
        ration: "16:9"
    };

    const setRef = useCallback(elem => {
        // console.log("ref", elem);
        if (elem) {
            plyrRef.current = new Plyr(elem, {
                ...defaultOptions,
                ...options
            });
            onPlayerInstance(plyrRef.current);

            plyrRef.current.on("controlshidden", event => {
                controlVisibilityChanged(false);
            });
            plyrRef.current.on("controlsshown", event => {
                controlVisibilityChanged(true);
            });
            plyrRef.current.on("play", () => {
                playingStatusChanged(true);
            });
            plyrRef.current.on("pause", () => {
                playingStatusChanged(false);
            });
            plyrRef.current.on("enterfullscreen", () => {
                fullScreenToggled(true);
            });
            plyrRef.current.on("exitfullscreen", () => {
                fullScreenToggled(false);
            });
        } else if (plyrRef.current) {
            plyrRef.current.destroy();
        }
    }, []);

    const VideoPlayer = (
        <video
            {...rest}
            src={url}
            ref={setRef}
            poster={defaultTo(poster, "")}
            playsInline={playsInline}
            controls={controls}
        />
        // <source src={url} type={mimeType} />

        // <a href={url} download>
        //     Download
        // </a>
        // </video>
    );

    return VideoPlayer;
}

Component.defaultProps = {} as AppPlyrProps;
Component.displayName = "AppPlyr";
export const AppPlyr = React.memo(Component);
export default AppPlyr;
